import { render, staticRenderFns } from "./TollManagement.vue?vue&type=template&id=c705a93a&"
import script from "./TollManagement.vue?vue&type=script&lang=js&"
export * from "./TollManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports